import React, { Component } from "react";
import Select from "react-select";
import { SkyLightStateless } from 'react-skylight';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import {
  Grid,
  Row,
  Col,
  Panel,
  Button,
  Tabs,
  Tab,
  ButtonToolbar,
  Breadcrumb,
  Dropdown,
  MenuItem,
  Input,
} from "react-bootstrap";
import { Translate } from "react-redux-i18n";
import { Toolbar, Data } from "react-data-grid-addons";
import ReactDataGrid from "react-data-grid";

import axios from 'axios';
import {
  ROOT_URL, //https://abc-scm.truckxi.com/api/
} from '../../../../actions/root_url';

// PUT--------    {{url}}v1/oversea-warehouse/change_location/37?location=222

// export const updateLocation = (salesOrderId, location, success) => {
//   axios({
//     method: 'PUT',
//     url: `${ROOT_URL}v1/oversea-warehouse/change_location/${salesOrderId}?location=${location}`,
//     headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
//   })
//   .then(res => {
//     success();
//   }, err => {
//     alert(err.statusText);
//   })
// }
const styles = {
  label: {
    textDecoration: 'underline',
    fontSize: '17px',
    fontWeight: 'bold',
    cursor: 'pointer'
  }
}

const modalStyle = {
  width: '500px',
  height: '300px',
  marginLeft: '-10%',
}

const propTypes = {
  selectedRows: PropTypes.array,
  onSuccess: PropTypes.func,
}

const defaultProps = {
  onSuccess: () => { },
  selectedRows: [],
}

class LabelPrint extends Component {
  // constructor(props) {
  //   super(props);
  //   this.state = {
  //     location: props.selectedRows.length ? props.selectedRows[0].Location : '',
  //   };
  // }

  // componentDidUpdate(prevProps,prevState){
  //   if (prevProps.selectedRows[0] !== this.props.selectedRows[0]) {
  //     this.setState({
  //       location: this.props.selectedRows[0] ? this.props.selectedRows[0].Location : ''
  //     })
  //   }
  // }

  // handleConfirmClick = () => {
  //   const {
  //     selectedRows,
  //     onSuccess,
  //   } = this.props;
  //   const {
  //     location,
  //   } = this.state;
  //   updateLocation(selectedRows[0].SalesOrder_id, location, onSuccess);
  // }
  generateShippingLabels = () => {
    if (!this.props.salesOrders.selectedRows.length) {
      return []
    }
    if (!this.props.salesOrders.selectedRows[0].PartialShipments) {
      return "No Label Found"
    }

    return this.props.salesOrders.selectedRows[0].PartialShipments.split(',').map(label => <li style={styles.label} onClick={() => this.handleLabelClick(label)}>{label}</li>)
  }

  handleLabelClick = (label) => {
    this.props.printPickingListPartial(label);
  }

  render() {
    return (
      <div style={{ width: '100%', height: '80%', padding: '10px', overflow: 'auto' }}>
        <div>
          <ul>
            {this.generateShippingLabels()}
          </ul>
        </div>
      </div>
    )
  }
}

const LabelPrintModal = ({ setModalVisibility, isVisible, salesOrders, printPickingListPartial }) => (
  <SkyLightStateless
    title={'Partial Shipments'}
    onCloseClicked={setModalVisibility}
    dialogStyles={modalStyle}
    isVisible={isVisible}
  >
    <LabelPrint salesOrders={salesOrders} printPickingListPartial={printPickingListPartial} />
  </SkyLightStateless>
)

LabelPrintModal.propTypes = propTypes
LabelPrintModal.defaultProps = defaultProps

export default LabelPrintModal;



// WEBPACK FOOTER //
// ./master/jsx/components/Common/modals/salesOrder/LabelPrintModal.jsx